
import React from "react";
import { Create } from "adminApi/ZoneTypeApi/ZoneType.js";
import { validateForm } from "utils/validation";
import { ZoneTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddZoneTypeForm from "./components/AddZoneTypeForm";
import fields from "../json/ZoneTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddZoneType = ({ setRefetch, refetch }) => {
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        ZoneTypeRules
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Create({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, ZoneTypeRules);
            setErrors(err);
            return err;
        },
        () => {
            setRefetch(!refetch);
            setValues(initialValues);
        },
        "Create Zone Type Successfully"
    );

    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddZoneTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Create Zone Type"
            />
        </>
    );
};

export default AddZoneType;
